import { memo, PropsWithChildren } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

type SortableItemProps = PropsWithChildren<{
  id: string;
  isDisabled?: boolean;
}>;

const SortableItem = ({ id, isDisabled, children }: SortableItemProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
    active,
  } = useSortable({
    id: id,
    disabled: isDisabled,
  });

  return (
    <div
      ref={setNodeRef}
      style={{
        position: "relative",
        transform: CSS.Translate.toString(transform),
        transition,
        zIndex: isDragging ? 999 : undefined,
        pointerEvents: active ? "none" : undefined,
        backgroundColor: isDragging ? "rgb(0 0 0 / 0.5)" : undefined,
      }}
      {...listeners}
      {...attributes}
    >
      {children}
    </div>
  );
};

export default memo(SortableItem);
